import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { CheckCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

type RefundPendingModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function RefundPendingModal({
  open,
  onOpenChange,
}: RefundPendingModalProps) {
  const { t } = useTranslation(["sales"]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md p-0 overflow-hidden">
        <div className="bg-gradient-to-br from-lime-500 to-lime-600 p-6 text-center">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-white/20 backdrop-blur-sm">
            <CheckCircle className="h-10 w-10 text-white" />
          </div>
          <DialogHeader className="mt-4">
            <DialogTitle className="text-xl font-bold text-white text-center">
              {t("refundRequestReceived")}
            </DialogTitle>
          </DialogHeader>
        </div>
        <div className="p-6">
          <DialogDescription asChild>
            <div className="space-y-4">
              <p className="text-sm text-muted-foreground">
                {t("refundRequestReceivedMessage")}
              </p>
              <div className="space-y-3 mt-4">
                <div>
                  <p className="text-sm font-semibold text-foreground mb-2">
                    {t("refundCreditDetailsTitle")}
                  </p>
                </div>
                <div className="space-y-2">
                  <p className="text-sm text-muted-foreground">
                    <strong>{t("refundCreditMethodLabel")}</strong>{" "}
                    {t("refundCreditMethodDescription")}
                  </p>
                  <p className="text-sm text-muted-foreground">
                    <strong>{t("refundEstimatedTimeLabel")}</strong>{" "}
                    {t("refundEstimatedTimeDescription")}
                  </p>
                  <p className="text-sm text-muted-foreground">
                    <strong>{t("refundNoteLabel")}</strong>{" "}
                    {t("refundNoteDescription")}
                  </p>
                </div>
              </div>
            </div>
          </DialogDescription>
          <DialogFooter className="mt-6">
            <Button onClick={() => onOpenChange(false)}>{t("understood")}</Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
